import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=9fa18ca2&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=9fa18ca2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa18ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa18ca2')) {
      api.createRecord('9fa18ca2', component.options)
    } else {
      api.reload('9fa18ca2', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=9fa18ca2&scoped=true", function () {
      api.rerender('9fa18ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/pcmenubar/Form.vue"
export default component.exports